<template>
  <div class="wrap">
    <!-- 顶部条 -->
    <topbar></topbar>
    <audio ref="audiome" style="display:none;"></audio>
    <!-- 主页面内容 -->
    <div ref="main" class="main" @click="enterSaver">
      <!-- 左侧地图模块 -->
      <div ref="left" class="left">

        <!-- 地图 -->
        <fengMap ref="fengMap" @loadComplete="loadComplete" @mapClickNode="mapClickNode"></fengMap>

        <!-- 地图控件 -->
        <div class="control">
          <!-- 聚焦按钮 -->
          <img class="focus-location" src="/images/preloader/map/button_current_01.png" alt="" @click="focusLocation">
          <!-- 缩放控件 -->
          <mapZoomCtrl style="margin-bottom:20px" @mapZoomChange="mapZoomChange"></mapZoomCtrl>
          <!-- 楼层控件 -->
          <mapFloorCtrl style="margin-bottom:20px" @changeFloor="clickChangeFloor"></mapFloorCtrl>

          <!-- 音量开关 -->
          <div v-if="isRunningSimulationNav" class="music-ctrl" style="margin-bottom:20px" @click="isPlay = !isPlay">
            <img v-if="isPlay" src="/images/preloader/music-open.png" alt />
            <img v-else src="/images/preloader/music-close.png" alt />
          </div>
          <!-- 地图模式2D/3D控件 -->
          <!-- <div v-if="mapViewMode" style="margin-bottom:20px" class="modeCtrl" :class="{ 'mode2d': mapViewMode === 'top', 'mode3d': mapViewMode === '3d'}" @click="change3D"></div> -->
          <div v-if="mapViewMode" style="margin-bottom:20px" class="modeCtrl" @click="change3D">
            <span v-if="$store.state.app.isPortrait">
              {{ mapViewMode == '4' ? '2D' : '3D' }}
            </span>
            <img v-else :src=" mapViewMode == '4' ? '/images/preloader/map/button_qiehuan_2d_01.png' : '/images/preloader/map/button_qiehuan_3d_01.png'" alt="" />
          </div>
          <!-- 模拟导航控制按钮 -->
          <div v-if="isRunningSimulationNav" class="simulationNav-btn">
            <div class="zanting" @click="stopSimulationNavTimer()">
              <span> {{ isSimulationNavTimer?'暂停' : '开始' }}</span>
              <img :src="isSimulationNavTimer ? '/images/preloader/btn-zanting.png' : '/images/preloader/btn-kaishi.png'" alt="">
            </div>
            <div class="sudu" @click="showSpeedSelect = !showSpeedSelect">
              <span>速度</span>
              <span style="color:#17da94;border:none;">{{ SIM_NAV_SPEED[curSimNavSpeedLevel].text }}</span>
              <div v-if="showSpeedSelect" class="select">
                <span v-for="(item, index) in SIM_NAV_SPEED" v-show="index !== curSimNavSpeedLevel" :key="index" class="select-btn" @click.stop="changeSpeed(index)">{{ item.text }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="changingPathType" class="is-changing">
          <img class="nav-img" :src="`/images/preloader/nav-${changingJson[changingPathType].icon}.png`" alt="">
          <div>{{ changingJson[changingPathType].txt }}</div>
        </div>

        <img v-if="imgTipVisible" class="tipImg" :src="navImgUrl" alt="" @click="imgTipVisible = false">

        <!-- poi分类 -->
        <div v-if="!$store.state.app.isPortrait" class="poi-categroy">
          <poiCategroy v-if="!isRunningSimulationNav" :data="poiCategroyList" @clickItem="searchPoiCategroy"></poiCategroy>
        </div>

        <!-- 导航方向提示/指引 -->
        <div v-if="isRunningSimulationNav" class="nav-tip">
          <div class="nav-tip-left">
            <img v-if="navTipIcon" :src="'/images/preloader/' + navTipIcon + '.png' " alt="">
            <div>{{ navTipMsg }}</div>
          </div>
          <div class="nav-tip-right">
            <div> 剩余{{ distance }}米</div>
            <div> {{ timeRemaining }}秒 </div>
          </div>
        </div>

      </div>

      <!-- 右侧功能模块 -->
      <div class="right">
        <!-- poi分类 -->
        <div v-if="$store.state.app.isPortrait&& curShowModel !== showModelEnum.poiSearchResult&& curShowModel !== showModelEnum.poiInfo&&curShowModel !== showModelEnum.route&&curShowModel !== showModelEnum.simNav" class="poi-categroy">
          <poiCategroy v-if="!isRunningSimulationNav" :data="poiCategroyList" @clickItem="searchPoiCategroy"></poiCategroy>
        </div>
        <!-- 右侧菜单 -->
        <sideMenu v-if="curShowModel === showModelEnum.sideMenu" @search="search" @selectMenuModule="selectMenuModule"></sideMenu>
        <!-- POI搜索结果列表 -->
        <poiSearchResult v-if="curShowModel === showModelEnum.poiSearchResult" ref="poiSearchResult" @clickItem="clickPoiItem" @changeIndex="changeIndex" @showSelectPoint="showSelectPoint" @close="closePoiSearchResult"></poiSearchResult>
        <!-- poi信息 -->
        <poiInfo v-if="curShowModel === showModelEnum.poiInfo" ref="poiInfo" @selectPoint="selectPoint" @return="returnPoiInfo" @close="closePoiInfo"></poiInfo>
        <!-- 路径规划 -->
        <route v-if="curShowModel === showModelEnum.route" ref="route" @routing="routing" @simulationNav="simulationNav" @changeStartOrEnd="changeStartOrEnd" @return="routeReturn" @close="routeClose"></route>
        <!-- 导航信息 -->
        <simNav v-if="curShowModel === showModelEnum.simNav" ref="simNav" @closeSimNav="closeSimNav"></simNav>
      </div>

      <!-- 二维码 -->
      <ercodeBlock v-if="$store.state.app.isPortrait" class="ercode-block"></ercodeBlock>
    </div>

    <!-- 功能模块 -->
    <!-- 查症状 -->
    <symptom v-if="symptomVisible" @close="symptomVisible = false" @guahao="guahao('挂号')" @daozhen="daozhen"></symptom>
    <!-- 找楼栋 -->
    <build v-if="buildVisible" @close="buildVisible = false" @selectPoi="selectPoi"></build>
    <!-- 找科室 -->
    <dept v-if="deptVisible" @close="deptVisible = false" @selectPoi="selectPoi"></dept>
    <!-- 找专家 -->
    <doctor v-if="doctorVisible" @guahao="guahaodoctor('挂号')" @close="doctorVisible = false" @selectPoi="selectPoi"></doctor>

    <!-- 医院介绍 -->
    <introd v-if="introdVisible" @close="introdVisible = false"></introd>

    <!-- 医院资讯 -->
    <info v-if="infoVisible" @close="infoVisible = false"></info>

    <!-- 弹窗 -->
    <!-- 模拟导航结束弹窗 -->
    <div v-if="simNavEndVisible" class="simNavEnd">
      <div class="container">
        <div class="title">已到达目的地，导航结束</div>
        <div class="subtitle">总里程{{ sim_distance || 0 }}米 共耗时{{ $moment(sim_expend).format('mm分ss秒') }}</div>
        <div class="journey">
          <div class="journey-item journey-start">
            <span style="display:inline-block;width:15px;height:15px;background:#17da94;border-radius:50%;"></span>
            <span class="name">{{ startPoint.name || '已选择的位置' }}</span>
            <span class="subInfo">({{ floorMapping[startPoint.floor] }})</span>
          </div>
          <div class="journey-item journey-end">
            <span style="display:inline-block;width:15px;height:15px;background:#ff5952;border-radius:50%;"></span>
            <span class="name">{{ endPoint.name || '已选择的位置' }}</span>
            <span class="subInfo">({{ floorMapping[endPoint.floor] }})</span>
          </div>
          <div class="fuzhudian">
            <i></i>
            <i></i>
          </div>
        </div>
        <div class="btn-group">
          <div class="close" @click="closeSimNav">退出</div>
          <div class="again" @click="againSimNav">重新模拟</div>
        </div>

      </div>
    </div>
    <el-image
      v-if="funModule[6] && funModule[6].checked"
      ref="image__preview"
      style="width: 10px; height: 10px;"
      class="no-show"
      :src="qiniuBaseUrl + funModule[6].bigImg"
      :preview-src-list="[qiniuBaseUrl + funModule[6].bigImg]"
    >
    </el-image>
    <!-- 屏保 -->
    <screen-saver v-if="saverShow" :saver-show.sync="saverShow" @updateSaverShow="enterSaver"></screen-saver>
  </div>
</template>

<script>
let curSimNavSpeedLevel = 0;
import Cookies from 'js-cookie';
import ReconnectingWebSocket from 'reconnecting-websocket'; // websocket重连插件
import eventEmitter from '@/utils/eventEmitter';
import fengMap from '@/components/fengMap';
import mapFloorCtrl from '@/components/mapFloorCtrl';
import mapZoomCtrl from '@/components/mapZoomCtrl';
import topbar from './topbar';
import poiCategroy from './poi';
import sideMenu from './sideMenu';
import poiSearchResult from './poiSearchResult';
import poiInfo from './poiInfo';
import route from './route';
import simNav from './simNav';
import symptom from './menu-symptom';
import build from './menu-build';
import dept from './menu-dept';
import doctor from './menu-doctor';
import introd from './menu-introd';
import info from './menu-info';
import screenSaver from './screen-saver';
import ercodeBlock from './ercode-block.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import { updateTextBuildId, textJson, addTextJson } from './updateText.js'; // 医院修改文本数据-定制化需求

const MAP_SCALE_LEVEL = 21;// 地图的缩放级别
const NAV_MAP_SCALE_LEVEL = 21; // 导航时的地图显示级别

let mapObj = null; // 蜂鸟地图实例
let locationMarker = null; // 定位标注
let deviInfo = null;
let isRotate = false;
let isTiltAngle = false;
let poiListMarkers = {}; // 显示在地图上的poi列表标注
let curPoiListMarkerInfo = null; // POI搜索后，会将结果列表显示在地图上，该值为当前选中项 {floor：x，id：x}
let curLocationMarker = {}; // 当前位置的marker标注
let fuzhuMarker = null; // 辅助marker
let grayLine = null; // 已走路线
let simulationNavStartTime = 0; // 模拟导航开始时间

// 隐藏文本-定制化需求
let searchResult = []
let analyser = null
let ctyytextMarkers = []

// 获取poi搜索结果所需标注图片
let getMarkerImage = (() => {
  // 提前加载poi标注所需图片
  let poiMarker1 = new Image(); // 未选中的poi标注背景图片
  let poiMarker2 = new Image(); // 选中的poi标注背景图片
  poiMarker1.src = '/images/preloader/map/marker1.png';
  poiMarker2.src = '/images/preloader/map/marker2.png';
  // 缓存图片
  let cacheImg = {
    unchecked: {}, // 未选中图片
    checked: {}// 选中图片
  };
  // 映射关系
  let mapping = {
    unchecked: poiMarker1,
    checked: poiMarker2
  };
  // 合成图片(图片 + 文字)，正方形
  let compositeImage = (image, text) => {
    let canvas = document.createElement('canvas');
    let imgWH = 52;
    let canvasWH = imgWH * 2;
    canvas.width = canvasWH;
    canvas.height = canvasWH;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(image, ((canvasWH - imgWH) / 2), ((canvasWH / 2) - imgWH), imgWH, imgWH);
    ctx.font = '18px Arial';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#fff';
    ctx.fillText(text, canvasWH / 2, (imgWH / 2) + 4);
    console.log('生成图片');
    return canvas.toDataURL('image/png');
  };

  return function (checkStatus, index) {
    // checkStatus 可能为 (unchecked、checked)其中一种
    if (!['unchecked', 'checked'].includes(checkStatus)) { throw Error('未定义该属性'); }
    // 如果有缓存的图片，则直接返回该图片
    if (cacheImg[checkStatus].hasOwnProperty(index)) {
      console.log('获取缓存图片');
      return cacheImg[checkStatus][index];
    }
    // 否则生成图片并返回
    return (cacheImg[checkStatus][index] = compositeImage(mapping[checkStatus], index));
  };
})();
export default {
  components: {
    fengMap,
    mapFloorCtrl,
    mapZoomCtrl,
    topbar,
    poiCategroy,
    sideMenu,
    poiSearchResult,
    poiInfo,
    route,
    simNav,
    symptom,
    build,
    dept,
    doctor,
    introd,
    screenSaver,
    info,
    ercodeBlock
  },
  props: {

  },
  data () {
    return {
      WS: null, // websocket
      checkForUpdatesTimer: null, // 版本检查更新定时器
      symptomVisible: false, // 查症状模块显示状态
      buildVisible: false, // 查楼栋模块显示状态
      deptVisible: false, // 找科室模块显示状态
      doctorVisible: false, // 找专家模块显示状态
      introdVisible: false, // 医院介绍模块显示状态
      infoVisible: false, // 医院资讯模块显示状态
      searchKey: null,
      mapViewMode: null, // 地图显示模式2D/3D
      isRunningSimulationNav: false, // 是否正在模拟导航
      poiSearchResultData: [], // 搜索结果数据
      routingList: [], // 路径规划数据
      routingListSection: [], // 路径规划数据转化
      curRouteFloorIndex: 0, // 当前所在规划楼层下标
      curCoordIndex: 0, // 当前走到节点的下标
      navTipMsg: '请直行11米', // 导航提示文本
      pathType: null, // 路径跨楼方式
      changingPathType: '', // 当前跨楼方式
      navTipIcon: 'front', // 提示icon
      isPlay: true, // 定义音频播放开关
      audio: null, // 定义音频播放对象
      navImgUrl: '', // 导航图片url地址
      navTipImgUrl: '', // 导航方向提示图片url地址
      imgTipVisible: false, // 导航提示图片显示状态
      isSimulationNavTimer: false, // 是否正在执行模拟导航定时器
      showSpeedSelect: false, // 是否暂时速度切换选项
      curSimNavSpeedLevel: 0, // 当前模拟导航速度等级
      simNavEndVisible: false, // 导航结束弹窗显示状态
      sim_distance: 0, // 模拟导航里程数
      sim_expend: 0, // 模拟导航耗时
      // 模拟导航速度等级划分
      SIM_NAV_SPEED: [
        { value: 400, text: '正常' },
        { value: 300, text: '中速' },
        { value: 200, text: '高速' }
      ],
      changingJson: {
        1: {
          icon: 'dianti',
          txt: '正在乘坐电梯'
        },
        10: {
          icon: 'futi',
          txt: '正在乘坐扶梯'
        },
        12: {
          icon: 'futi',
          txt: '正在乘坐扶梯'
        },
        20: {
          icon: 'louti',
          txt: '正在上楼梯'
        },
        21: {
          icon: 'xialou',
          txt: '正在下楼梯'
        }
      },
      curShowModel: 'sideMenu', // 当前右侧显示模块
      showModelEnum: { // 右侧模块枚举
        sideMenu: 'sideMenu',
        poiSearchResult: 'poiSearchResult',
        poiInfo: 'poiInfo',
        route: 'route',
        simNav: 'simNav'
      }
    };
  },
  computed: {
    // 建筑信息
    deviInfo: {
      get () { return this.$store.state.app.deviInfo; },
      set (val) { this.$store.commit('app/set_deviInfo', val); }
    },
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    // 功能权限
    funModule () {
      let basiSetting = this.$store.state.app.baseSettingInfo.basiSetting;
      console.log('basiSetting', basiSetting);
      return basiSetting && basiSetting.funModule ? JSON.parse(basiSetting.funModule) : [];
    },
    // 百度token
    baiduToken: {
      get () { return this.$store.state.app.baiduToken; },
      set (val) { this.$store.commit('app/set_baiduToken', val); }
    },
    // 地图楼层ID集合
    mapFloorIdList: {
      get () { return this.$store.state.nav.mapFloorIdList; },
      set (val) { this.$store.commit('nav/set_mapFloorIdList', val); }
    },
    // 地图当前聚焦楼层
    mapFocusFloor: {
      get () { return this.$store.state.nav.mapFocusFloor; },
      set (val) { this.$store.commit('nav/set_mapFocusFloor', val); }
    },
    // 起点
    startPoint: {
      get () { return this.$store.state.nav.startPoint; },
      set (val) { this.$store.commit('nav/set_startPoint', val); }
    },
    saverShow: {
      get () { return this.$store.state.nav.saverShow; },
      set (val) { this.$store.commit('nav/set_saverShow', val); }
    },
    // 终点
    endPoint: {
      get () { return this.$store.state.nav.endPoint; },
      set (val) { this.$store.commit('nav/set_endPoint', val); }
    },
    // 七牛图片地址
    qiniuBaseUrl () {
      return this.$store.state.app.qiniuBaseUrl;
    },
    // 功能模块
    FUN_MODULE () {
      return this.$store.state.app.FUN_MODULE;
    },
    // 地图楼层映射
    floorMapping () {
      return this.$store.getters['nav/floorMapping'];
    },
    // poi分类列表
    poiCategroyList () {
      return this.$store.state.nav.poiCategroyList;
    },
    // 所有节点
    allNodeList () {
      return this.$store.state.nav.allNodeList;
    },
    // 当前地图所有节点的集合，键值对形式（以ID为键值）
    allNodeObjById () {
      return this.$store.getters['nav/allNodeObjById'];
    },
    // 当前地图所有POI的集合，键值对形式（以poiId为键值）
    allPoiObjById () {
      return this.$store.getters['nav/allPoiObjById'];
    },
    // 当前地图所有节点的集合，按楼层划分 { floor: [...node] }
    allNodeFloorObj () {
      return this.$store.getters['nav/allNodeFloorObj'];
    },
    // 当前地图所有POI的集合，按楼层划分 { floor: [...poi] }
    allPoiFromFloor () {
      return this.$store.getters['nav/allPoiFromFloor'];
    },
    // 返回路径规划所有点（已分段）的数组
    routePartitionArr () {
      let arr = [];
      this.routingListSection.forEach(item => {
        arr.push(...item.data);
      });
      return arr;
    },
    // 返回剩余路程（距离）
    distance () {
      // 剩余路程 = 当前点 到 最后一点 之间每两点距离的总和
      // 当前点下标 = 已走过的楼层的点数 + 当前所在路径的下标

      // 路径所有分段节点数量
      let partitionArrlength = this.routePartitionArr.length;

      // 之前楼层经过的节点数量
      let pastPointTotal = 0;

      for (let i = 0; i < this.curRouteFloorIndex; i++) {
        pastPointTotal += this.routingListSection[i].data.length - 1;
      }

      let startIndex = pastPointTotal + this.curCoordIndex;// 当前所在路径上的下标
      let totalDistance = 0;// 总长度
      let twoPointDistance = 0;
      let curNode = null;
      let nextNode = null;

      for (let i = startIndex; i < partitionArrlength; i++) {
        if (i === partitionArrlength - 1) break;
        curNode = this.routePartitionArr[i];
        nextNode = this.routePartitionArr[i + 1];
        twoPointDistance = this.$utils.getTwoPointsDistance(curNode, nextNode);
        totalDistance += twoPointDistance;
      }

      return parseInt(totalDistance);
    },
    // 返回剩余时间
    timeRemaining () {
      if (this.isRunningSimulationNav) {
        return parseInt((this.distance / 2.2));
      } else if (this.isRunningRealNav) {
        return parseInt((this.distance / 90) * 60);
      } else {
        return 0;
      }
    },
    ...mapState('nav', [
      'saverData'
    ])
  },
  watch: {
    // 监听播放按钮状态
    isPlay (val) {
      if (this.audio) {
        if (!val) {
          // this.audio.pause();
          this.audio = null;
        }
      }
    }
  },
  async mounted () {
    if (!this.deviInfo.screenId) {
      this.$router.push({ path: '/' });
    }
    deviInfo = this.allNodeObjById[this.deviInfo.nodeId];
    this.startPoint = this.allNodeObjById[this.deviInfo.nodeId];
    await this.getScreenProtectDetail();
    await this.getSettingDetail();
    // 链接WS
    this.connectWS();
  },
  beforeDestroy () {
    eventEmitter.off('focusGroupIDChanged', this.showCurLocationInMap);
  },
  destroyed () {
    console.log('页面销毁页面销毁页面销毁页面销毁');
    this.WS && this.WS.close();
  },
  methods: {
    async getSettingDetail () {
      try {
        if (this.buildInfo.buildId) {
          let res = await this.$apis.third.getSettingDetail({ buildId: this.buildInfo.buildId });
          if (res.data) {
            let data = JSON.parse(res.data);
            console.log(data, 'getSettingDetail');
            curSimNavSpeedLevel = data.naviRate ? data.naviRate - 1 : 0;
            isRotate = data.rotate === 1;
            isTiltAngle = data.tiltAngle === 1;
            if (data.refreshTime || this.saverData.protectType > 0) {
              this.set_initData(data);
              let x = null;
              let y = null;
              this.enterSaver();
              document.onmousemove = (event) => {
                let x1 = event.clientX;
                let y1 = event.clientY;
                if (x !== x1 || y !== y1) {
                  this.enterInit();
                  this.enterSaver();
                }
                x = x1;
                y = y1;
              };
              // 监听键盘
              document.onkeydown = () => {
                this.enterInit();
                this.enterSaver();
              };
            }
          }
          this.$refs.main.addEventListener('touchstart', this.enterSaver); // 手指放到屏幕上时触发
          this.$refs.main.addEventListener('touchstart', this.enterInit); // 手指放到屏幕上时触发
          this.$refs.main.addEventListener('touchmove', this.enterSaver);// 手指在屏幕上滑动式触发
          this.$refs.main.addEventListener('touchmove', this.enterInit);// 手指在屏幕上滑动式触发
        }
      } catch (error) {
        console.error('getSettingDetail', error);
        return {};
      }
    },
    async getScreenProtectDetail () {
      try {
        if (this.buildInfo.buildId) {
          let res = await this.$apis.third.getScreenProtectDetail({ buildId: this.buildInfo.buildId });
          // let res = {"msg":"success","code":0,"data":"[{\"id\":\"1\",\"buildId\":\"1158648401865236482\",\"custId\":\"0\",\"protectType\":2,\"protectTime\":\"1\",\"isCustomerProtect\":1,\"protectImage\":\"[\\\"Fiu5ZYIPvcYRjFiOZxeTQJDRA_mc\\\",\\\"FjpD82NCJGZIbX6NjKESkWw--rPU\\\"]\",\"protectImageRunTime\":\"3\",\"protectVedio\":\"[\\\"Fk7vbuW9VhwrLx365Gb7c8NSFFrt\\\",\\\"FoIjirqTydf9Yf0UBtG9GPTVRrVp\\\"]\"}]"}
          if (res.data) {
            console.log('getScreenProtectDetail', JSON.parse(res.data));
            let data = JSON.parse(res.data);
            if (data.protectType !== 0) {
              this.set_saverData(data);
            }
          }
        }
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    ...mapActions('nav', [
      // 调用定时器
      'enterSaver',
      'enterInit'
    ]),
    ...mapMutations('nav', [
      'set_saverData',
      'set_initData'
    ]),
    // 选择poi目的地
    selectPoi (poiId, name, fromModule) {
      console.log('选中的poiId:', poiId);
      console.log('name:', name);
      console.log('fromModule:', fromModule);
      console.log('POI数据:', this.allPoiObjById);

      // 如果不存在poiId信息，则提示
      if (!this.allPoiObjById.hasOwnProperty(poiId)) {
        this.$message.info('暂无poi数据');
        return;
      }
      // 根据id获取poi信息数据，如果形参含有name，则替换显示名字
      let poi = JSON.parse(JSON.stringify(this.allPoiObjById[poiId]));
      if (name) { poi.name = name ; }
      console.log('poi信息:', poi);

      // 添加临时辅助标注
      this.addFuzhuMarker(poi);

      // 显示右侧poi信息模块
      this.curShowModel = this.showModelEnum.poiInfo;
      this.$nextTick(() => {
        this.$refs.poiInfo.init(poi, fromModule);
      });
    },
    // 挂号
    guahao (key) {
      this.symptomVisible = false;
      this.search(key);
    },
    // 导诊
    daozhen (e) {
      this.symptomVisible = false;
      const _item = this.allNodeObjById[e.poiId];
      this.changeFloor(parseInt(e.floor), () => {
        this.closePoiSearchResult();
        // 添加临时标注点
        this.addFuzhuMarker(_item);
        this.curShowModel = this.showModelEnum.poiInfo;
        this.$nextTick(() => {
          this.$refs.poiInfo.init(_item, 'clickMap');
        });
      });
    },
    // 挂号
    guahaodoctor (key) {
      console.log('专家跳转挂号');
      this.doctorVisible = false;
      this.search(key);
    },
    // 路径规划返回
    routeReturn (poiData, fromModule) {
      console.log('路径规划返回:', poiData, fromModule);

      // 清空起点终点marker标注
      this.$refs.fengMap.clearNaviAll();
      // 取消监听楼层切换绘制路径
      eventEmitter.off('focusGroupIDChanged', this.addCurFloorRouteInMap);

      if (this.poiSearchResultData.length > 0) {
        this.search(this.searchKey);
        // this.curShowModel = this.showModelEnum.poiSearchResult;
      } else if (poiData && fromModule) {
        if (fromModule === 'clickMap') {
          // 添加临时辅助标注
          this.addFuzhuMarker(poiData);
          // 显示右侧poi信息模块
          this.curShowModel = this.showModelEnum.poiInfo;
          this.$nextTick(() => {
            this.$refs.poiInfo.init(poiData, fromModule);
          });
        } else {
          this.selectPoi(poiData.poiId, poiData.name, fromModule);
        }
      } else {
        this.curShowModel = this.showModelEnum.sideMenu;
      }
    },
    // 路由关闭
    routeClose () {
      // 清空导航路线
      this.$refs.fengMap.clearLines();
      // 清空起点终点marker标注
      this.$refs.fengMap.clearNaviAll();
      // 取消监听楼层切换绘制路径
      eventEmitter.off('focusGroupIDChanged', this.addCurFloorRouteInMap);
      // 切换右侧菜单
      this.curShowModel = this.showModelEnum.sideMenu;
    },
    // 选择功能模块
    selectMenuModule (moduleName) {
      console.log('选择功能模块：', moduleName);
      switch (moduleName) {
        case this.FUN_MODULE.SYMPTOM:
          this.symptomVisible = true;
          break;
        case this.FUN_MODULE.BUILDING:
          this.buildVisible = true;
          break;
        case this.FUN_MODULE.DEPT:
          this.deptVisible = true;
          break;
          // 找专家
        case this.FUN_MODULE.DOCTOR:
          this.doctorVisible = true;
          break;

          // 医院介绍
        case this.FUN_MODULE.INTROD:
          this.introdVisible = true;
          break;

          // 医院资讯
        case this.FUN_MODULE.INFO:
          this.infoVisible = true;
          break;

          // 排班信息
        case this.FUN_MODULE.ALLOT:
          console.log('this.$refs.image__preview', this.$refs.image__preview);
          this.$refs.image__preview.clickHandler();
          this.$nextTick(() => {
            // 获取遮罩层dom
            let domImageMask = document.querySelector('.el-image-viewer__mask');
            if (!domImageMask) {
              return;
            }
            domImageMask.addEventListener('click', () => {
              // 点击遮罩层时调用关闭按钮的 click 事件
              document.querySelector('.el-image-viewer__close').click();
            });
          });
          break;

        default:
          this.$message.info('该功能模块暂未开放');
          break;
      }
    },
    // 重新模拟
    againSimNav () {
      this.closeSimNav();
      let endCoord = { x: this.endPoint.x, y: this.endPoint.y, groupID: this.endPoint.floor };
      this.$refs.fengMap.setNaviStartOrEndPoint(endCoord, 0);
      this.routing(this.routingList, this.pathType);
      this.simulationNav();
    },
    // 关闭模拟导航
    closeSimNav () {
      // 重置模拟导航状态
      this.isRunningSimulationNav = false;
      // 重置模拟导航定时器运行状态
      this.isSimulationNavTimer = false;
      // 隐藏定位标注
      locationMarker.visible = false;
      // 清空模拟导航定时器
      clearInterval(this.simulationNavTimer);
      // 清空导航路线
      this.$refs.fengMap.clearLines();
      if (grayLine) {
        this.$refs.fengMap.clearLines(grayLine);
      }
      // 清空起点终点marker标注
      this.$refs.fengMap.clearNaviAll();
      // 关闭模拟导航结束弹窗
      this.simNavEndVisible = false;
      // 取消监听楼层切换绘制路径
      eventEmitter.off('focusGroupIDChanged', this.addCurFloorRouteInMap);
      // 切换右侧菜单
      this.curShowModel = this.showModelEnum.sideMenu;
    },
    // 模拟导航
    simulationNav () {
      console.log('开始模拟导航');
      simulationNavStartTime = new Date().getTime();
      this.isRunningSimulationNav = true;

      this.curRouteFloorIndex = 0;
      this.curCoordIndex = 0;
      this.sim_distance = this.distance;
      this.curShowModel = this.showModelEnum.simNav;
      this.$nextTick(() => {
        this.$refs.simNav.init({ time: this.timeRemaining, distance: this.sim_distance });
      });

      // 提前加载路径上的图片
      this.routingList.forEach(item => {
        if (item.hasOwnProperty('image')) {
          let img = new Image();
          img.src = this.qiniuBaseUrl + item.image;
        }
      });

      this.navTipMsg = '开始导航';
      this.playAudio(this.navTipMsg, this.isPlay);
      console.log('模拟导航开始', this.audio);
      this.curSimNavSpeedLevel = curSimNavSpeedLevel;

      // 设置地图角度、缩放、显示定位图标
      let startNode = this.routingListSection[0].data[0];
      this.changeFloor(parseInt(startNode.floor), () => {
        mapObj.setCenter({ x: startNode.x, y: startNode.y });
        mapObj.setZoom({ zoom: Number(NAV_MAP_SCALE_LEVEL) });
        // startNode.angle && mapObj.setRotation({ rotation: (360 + 90 - startNode.angle), duration: 1 });
        this.setLocationMarkerPosition({ x: startNode.x, y: startNode.y, level: startNode.floor });
        // // 执行模拟导航定时器
        this.simulationNavTimerFn();
      });
    },
    // 播放语音
    playAudio (txt, isPlay) {
      if (!isPlay) { return ; }
      this.audio = this.$refs.audiome;
      this.audio.src = `https://tsn.baidu.com/text2audio?lan=zh&cuid=0&ctp=1&tok=${this.baiduToken}&tex=${encodeURI(encodeURI(txt))}`;
      this.audio.pause();
      this.audio.play();
    },
    // 模拟导航定时器
    simulationNavTimerFn () {
      console.log('isSimulationNavTimer');
      this.isSimulationNavTimer = true;
      let curFloorRouteData = null; // 当前楼层路径数据
      let routeFloorsTotal = this.routingListSection.length; // 路径楼层总数

      // 模拟导航定时器
      this.simulationNavTimer = setInterval(() => {
        curFloorRouteData = this.routingListSection[this.curRouteFloorIndex].data;
        // 判断是否结束导航
        if (this.curCoordIndex >= curFloorRouteData.length - 1) {
          // 如果当前楼层与终点楼层相同，则结束导航
          if (this.curRouteFloorIndex === (routeFloorsTotal - 1)) {
            console.log('到达终点');
            this.playAudio('已经到达目的地附近，感谢使用导航', this.isPlay);
            console.log('模拟导航结束', this.audio);
            // 计算耗时
            this.sim_expend = new Date().getTime() - simulationNavStartTime;

            this.simNavEndVisible = true;

            clearInterval(this.simulationNavTimer);
            this.isRunningSimulationNav = false;

            return;
          } else {
            clearInterval(this.simulationNavTimer);
            this.changingPathType = curFloorRouteData[this.curCoordIndex].type;
            setTimeout(() => {
              this.ischanging = false;
              this.changingPathType = '';
              // 否则跳转到下一楼层
              this.curRouteFloorIndex++;
              this.curCoordIndex = 0;
              let nextFloorObj = this.routingListSection[this.curRouteFloorIndex];
              let nextFloorStartPoint = nextFloorObj['data'][this.curCoordIndex];
              console.log('curRouteFloorIndex', this.curRouteFloorIndex, nextFloorObj);
              this.changeFloor(parseInt(nextFloorObj.floor), () => {
                mapObj.setCenter({ x: nextFloorStartPoint.x, y: nextFloorStartPoint.y });
                locationMarker.moveTo({ x: nextFloorStartPoint.x, y: nextFloorStartPoint.y, level: parseInt(nextFloorObj.floor) });
                this.simulationNavTimerFn();
              });
            }, 2000);
          }
        }

        let curNode = curFloorRouteData[this.curCoordIndex];
        let tipNode = curFloorRouteData[this.curCoordIndex + 6];

        // 重绘导航线（实现已走路径变灰效果）
        let arr = this.routingListSection[this.curRouteFloorIndex].data.slice(0, this.curCoordIndex + 1);
        let lineData = this.nodeDataTranform(arr, 1.05);
        if (grayLine) {
          this.$refs.fengMap.clearLines(grayLine);
        }
        grayLine = this.$refs.fengMap.drawLines(lineData);

        // 地图与定位图标 旋转、移动
        mapObj.setCenter({ x: curNode.x, y: curNode.y, animate: true, duration: (this.SIM_NAV_SPEED[this.curSimNavSpeedLevel].value / 1000) - 0.05 });
        curNode.angle && locationMarker.rotateTo({ heading: (270 + curNode.angle), duration: 0.5, animate: true });
        locationMarker.moveTo({ x: curNode.x, y: curNode.y, animate: true, duration: (this.SIM_NAV_SPEED[this.curSimNavSpeedLevel].value / 1000) - 0.05 });

        // 显示导航方向提示，并开启语音提示
        this.navTipMsg = curNode.text;
        this.navTipIcon = curNode.icon;
        if (curNode.isSpeak && this.isPlay) {
          console.log('音频是否结束：', this.audio);
          if (this.audio) { console.log(this.audio.ended); }
          if ((this.audio && this.audio.ended) || (this.audio === null)) {
            this.playAudio(this.navTipMsg, this.isPlay);
          }
        }

        // 关键点显示图片
        if (tipNode && tipNode.hasOwnProperty('image') && tipNode.image !== '') {
          // if (tipNode.nextFloor && tipNode.floor && tipNode.type) {
          //   // console.log(this.curBuild.floorNameList, '楼层映射555555');
          //   this.NavNextFloor = tipNode.nextFloor;
          //   if (tipNode.floor > tipNode.nextFloor) {
          //     this.navTipImgUrl = 'goDown';
          //   } else {
          //     this.navTipImgUrl = 'goUp';
          //   }
          // }
          console.log('navTipImgUrl', this.navTipImgUrl);
          this.navImgUrl = this.qiniuBaseUrl + tipNode.image;
          this.imgTipVisible = true;
          console.log('显示实景图：');
          console.log(this.navImgUrl);
          setTimeout(() => {
            this.imgTipVisible = false;
            this.navImgUrl = null;
            console.log('定时关闭实景图');
          }, 6000);
          eventEmitter.once('focusGroupIDChanged', () => {
            console.log('切换楼层关闭实景图');
            this.imgTipVisible = false;
            this.navImgUrl = null;
          });
        }
        // 下标增加，下一次定时器执行就会拿到下一点数据
        this.curCoordIndex++;
        this.enterInit();
        this.enterSaver();
      }, this.SIM_NAV_SPEED[this.curSimNavSpeedLevel].value);
    },
    // 暂停模拟导航
    stopSimulationNavTimer () {
      // 是否正在执行模拟导航定时器
      this.isSimulationNavTimer = !this.isSimulationNavTimer;
      if (this.isSimulationNavTimer) {
        // 执行模拟导航定时器
        this.simulationNavTimerFn();
      } else {
        // 暂停模拟导航定时器
        clearInterval(this.simulationNavTimer);
      }
    },
    // 模拟导航速度调整
    changeSpeed (index) {
      this.showSpeedSelect = false;
      this.stopSimulationNavTimer();
      this.curSimNavSpeedLevel = index;
      this.stopSimulationNavTimer();
    },
    // 路径规划
    routing (paths, pathType, sectionLength = 0.5) {
      let time = new Date().getTime();
      if (paths.length === 0) {
        this.$message.error('没有找到该类型路径，请更换类型再试');
      }
      this.routingList = paths;

      // 过滤非本建筑节点
      this.routingList = this.routingList.filter((item) => {
        return item.buildId === this.buildInfo.buildId;
      });

      this.$refs.fengMap.clearLines();
      this.routingListSection = this.$utils.routeDataTransform(this.routingList, sectionLength, this.buildInfo.floorNameList);
      // console.log('路径数据转化：', this.routingListSection);
      console.log('跨楼方式', pathType);
      this.pathType = pathType;

      // 平滑处理
      let partition = this.$utils.partition(this.routingList, 'floor');
      console.log('partitionpartitionpartitionpartitionpartition', partition);
      // 过滤路径只有一个点的楼层，防止楼层频繁切换
      partition = partition.filter((item, index) => {
        return item['data'].length > 1 || index === 0 || index === partition.length - 1;
      });
      partition.forEach((item, index) => {
        let lineData = this.nodeDataTranform(item.data);
        let line = this.$refs.fengMap.getLineData(lineData);
        let fmapLineDate = line.segments[0]['pv'];
        // 路径分段
        let routeDataSection = [];
        for (let i = 0; i < fmapLineDate.length; i++) {
          routeDataSection.push(fmapLineDate[i]);
          if (i === fmapLineDate.length - 1) break;
          let cur = fmapLineDate[i];
          let next = fmapLineDate[i + 1];
          let diffX = next.x - cur.x;
          let diffY = next.y - cur.y;
          let distance = this.$utils.getTwoPointsDistance(cur, next);
          let sectionTotal = Math.round(distance / 0.25);
          let incX = diffX / sectionTotal;
          let incY = diffY / sectionTotal;
          for (let j = 1; j < sectionTotal; j++) {
            let obj = {
              x: cur.x,
              y: cur.y
            };
            obj.x += j * incX;
            obj.y += j * incY;
            routeDataSection.push(obj);
          }
        }
        console.log('补充后的点数:', routeDataSection.length);
        partition[index]['data'] = routeDataSection;
      });

      this.routingListSection.forEach((item, index) => {
        item['data'].forEach((item2, index2) => {
          let minDistance = 999;
          let minIndex = null;
          let distance = null;

          partition[index]['data'].forEach((item3, index3) => {
            distance = this.$utils.getTwoPointsDistance(item2, item3);

            if (distance < minDistance) {
              minDistance = distance;
              minIndex = index3;
            }
          });
          item2.x = partition[index]['data'][minIndex].x;
          item2.y = partition[index]['data'][minIndex].y;
        });
      });

      console.log(this.routingListSection);
      console.log('耗时：', new Date().getTime() - time);

      // let lineData = this.nodeDataTranform(this.routingListSection[0]['data']);
      // console.log('导航线数据(蜂鸟格式数据)：');
      // console.log(lineData);

      // this.addCurFloorRouteInMap({ gid: this.mapFocusFloor });
      // 监听楼层切换时，将路径绘制到地图上
      eventEmitter.on('focusGroupIDChanged', this.addCurFloorRouteInMap);

      console.log('路径规划完成！');
    },
    // 节点数据转化, 将节点信息转化成线数据
    nodeDataTranform (nodeData, height = 1) {
      let arr = [];
      let obj = {};
      nodeData.forEach(node => {
        if (obj.hasOwnProperty(node.floor + 'F')) {
          obj[node.floor + 'F']['points'].push({ x: node.x, y: node.y, z: height });
        } else {
          obj[node.floor + 'F'] = {
            groupId: parseInt(node.floor),
            points: [{ x: node.x, y: node.y, z: height }]
          };
        }
      });
      Object.keys(obj).forEach(key => {
        arr.push(obj[key]);
      });
      return arr;
    },
    // 将当前楼层对应的路径添加到地图上
    addCurFloorRouteInMap (event) {
      console.log('addCurFloorRouteInMap', event);
      let floor = event.level;
      // 清空地图上所有线
      this.$refs.fengMap.clearLines();

      this.routingListSection.forEach(item => {
        let curFloor = item.floor;
        if (curFloor && parseInt(curFloor) === parseInt(floor)) {
          let lineData = this.nodeDataTranform(item.data);
          this.$refs.fengMap.getLineData(lineData);
          console.info('绘制绿色路径');
        }
      });
    },
    // 对换起点终点
    changeStartOrEnd () {
      // 更换起点终点
      let start = this.startPoint;
      if (start.nodeId) {
        start.id = start.nodeId;
      }
      let end = this.endPoint;
      this.startPoint = end;
      this.endPoint = start;
      // 判断更改终点起点标注
      if (JSON.stringify(this.endPoint) !== '{}') {
        let endCoord = { x: this.endPoint.x, y: this.endPoint.y, groupID: this.endPoint.floor };
        this.$refs.fengMap.setNaviStartOrEndPoint(endCoord, 0);
      }
      if (JSON.stringify(this.startPoint) !== '{}') {
        let startCoord = { x: this.startPoint.x, y: this.startPoint.y, groupID: this.startPoint.floor };
        this.$refs.fengMap.setNaviStartOrEndPoint(startCoord, 1);
      }
      // 两个都不为空的时候规划路径
      if (JSON.stringify(this.endPoint) !== '{}' && JSON.stringify(this.startPoint) !== '{}') {
        this.$nextTick(() => {
          this.$refs.route.init();
        });
      }
    },
    // POI返回
    returnPoiInfo (fromModule) {
      this.closePoiInfo();
      console.log('返回模块', fromModule);
      switch (fromModule) {
        case this.FUN_MODULE.SYMPTOM:
          this.symptomVisible = true;
          break;
        case this.FUN_MODULE.BUILDING:
          this.buildVisible = true;
          break;
        case this.FUN_MODULE.DEPT:
          this.deptVisible = true;
          break;

        default:
          break;
      }
    },
    // 关闭poi信息窗口
    closePoiInfo () {
      if (fuzhuMarker) {
        fuzhuMarker.visible = false;
      }
      this.curShowModel = this.showModelEnum.sideMenu;
      // 清空导航路线
      this.$refs.fengMap.clearLines();
      // 清空起点终点marker标注
      this.$refs.fengMap.clearNaviAll();
      // 取消监听楼层切换绘制路径
      eventEmitter.off('focusGroupIDChanged', this.addCurFloorRouteInMap);
      eventEmitter.off('focusGroupIDChanged', this.addPoiMarkerInMap);
    },
    // 关闭poi搜索结果窗口
    closePoiSearchResult () {
      this.poiSearchResultData = [];
      this.searchKey = null;
      this.clearPoiMarkerInMap();
      this.curShowModel = this.showModelEnum.sideMenu;
      // 清空导航路线
      this.$refs.fengMap.clearLines();
      // 清空起点终点marker标注
      this.$refs.fengMap.clearNaviAll();
      // 取消监听楼层切换绘制路径
      eventEmitter.off('focusGroupIDChanged', this.addCurFloorRouteInMap);
      eventEmitter.off('focusGroupIDChanged', this.addPoiMarkerInMap);
    },
    // 搜索poi分类
    searchPoiCategroy (data) {
      console.log('搜索POI分类：', data);
      this.search(data.poiName);
    },
    // 选中poi
    selectPoint (poiData, fromModule) {
      console.log('选中poi：', poiData);
      // 设置起点、终点
      this.endPoint = poiData;
      this.startPoint = this.allNodeObjById[this.deviInfo.nodeId];

      // 清空标注
      this.clearPoiMarkerInMap();
      eventEmitter.off('focusGroupIDChanged', this.addPoiMarkerInMap);
      if (fuzhuMarker) { fuzhuMarker.visible = false; }

      // 设置起点、终点标注
      let coord = { x: poiData.x, y: poiData.y, groupID: poiData.floor };
      this.$refs.fengMap.setNaviStartOrEndPoint(coord, 0);
      let coord2 = { x: this.startPoint.x, y: this.startPoint.y, groupID: this.startPoint.floor };
      this.$refs.fengMap.setNaviStartOrEndPoint(coord2, 1);

      // 显示路径规划模块
      this.curShowModel = this.showModelEnum.route;
      this.$nextTick(() => {
        this.$refs.route.init(poiData, fromModule);
      });
    },
    testFn () {
      mapObj.setCenter({ x: 12612610.429671874, y: 2638949.8687958983 });
    },
    // 搜索poi
    async search (key) {
      if (fuzhuMarker) {
        fuzhuMarker.visible = false;
      }
      this.searchKey = key;
      // 搜索结果
      let res = await this.searchPoiApi(key, this.buildInfo.buildId);
      let parseData = res;

      if (parseData.length === 0) { this.$message.info('暂无poi数据'); }
      console.log('deviInfo', deviInfo);
      // 距离排序
      if (deviInfo.floor) {
        parseData.forEach((item) => {
          let distance = this.$utils.getTwoPointsDistance(deviInfo, item) || 99999;
          item.distance = distance;
        });
        parseData = this.$utils.JsonSort(parseData, 'distance');
      }

      // 按楼层排序
      parseData.sort((a, b) => {
        return a.floor - b.floor;
      });
      // 选出当前楼层的poi
      let curFloorPoi = [];
      for (let i = 0; i < parseData.length; i++) {
        if (parseData[i].floor === this.mapFocusFloor) {
          const element = parseData.splice(i, 1);
          curFloorPoi.push(...element);
          i--;
        }
      }
      // 将当前楼层的poi放到最前
      parseData.unshift(...curFloorPoi);
      this.poiSearchResultData = parseData;

      this.changeFloor(parseInt(parseData[0].floor));
      setTimeout(() => {
        this.addPoiMarkerInMap();
        console.log('画点标注');
        this.changeIndex(parseData[0], 0);
        eventEmitter.on('focusGroupIDChanged', this.addPoiMarkerInMap);
      }, 600);

      // 显示右侧搜素结果模块
      this.curShowModel = this.showModelEnum.poiSearchResult;
      // 传入数据
      this.$nextTick(() => {
        this.$refs.poiSearchResult.init(res);
      });
    },
    // 将poi信息显示在地图上
    addPoiMarkerInMap () {
      console.log('绘制');
      // 清除所有dom标注
      this.clearPoiMarkerInMap();
      // 遍历poi列表，添加标注到地图上
      let poiList = this.poiSearchResultData;
      console.log('将poiList显示在地图上:', poiList);

      poiList.forEach((item, index) => {
        // 过滤掉非当前楼层poi
        if (item.floor !== this.mapFocusFloor) { return; }
        // 创建对象，存放marker
        if (!Object.prototype.hasOwnProperty.call(poiListMarkers, item.floor)) {
          poiListMarkers[item.floor] = {};
        }
        let imageMarker = this.$refs.fengMap.addImageMarker({ x: item.x, y: item.y, size: 104, url: getMarkerImage('unchecked', index + 1) });
        poiListMarkers[item.floor][item.poiId] = { imageMarker };
      });
    },
    // 清除地图上显示的POI信息
    clearPoiMarkerInMap () {
      console.log('清除', poiListMarkers);
      Object.keys(poiListMarkers).forEach(item => {
        Object.keys(poiListMarkers[item]).forEach(item2 => {
          let obj = poiListMarkers[item][item2];
          console.log('obj', obj);
          obj.imageMarker.remove();
        });
      });

      poiListMarkers = {};
      curPoiListMarkerInfo = null;
    },
    // 点击了poi 手动触发
    clickPoiItem (item, index) {
      console.log('---------手动点击---------');
      this.selectPoi(item.poiId, item.name, 'floor');
      // this.selectPoint(item.poiId, item.name, 'floor');
      this.curShowModel = this.showModelEnum.poiInfo;
      // this.curShowModel = false
    },
    // 改变选中的poi
    changeIndex (item, index) {
      console.log('---------开始---------');
      console.log('poiListMarkers:', poiListMarkers);
      console.log('curPoiListMarkerInfo:', curPoiListMarkerInfo);
      this.changeFloor(parseInt(item.floor), () => {
        mapObj.setCenter({ x: item.x, y: item.y });
        poiListMarkers[item.floor][item.poiId]['imageMarker'].url = getMarkerImage('checked', index + 1);
        if (curPoiListMarkerInfo) {
          poiListMarkers[curPoiListMarkerInfo.floor][curPoiListMarkerInfo.id]['imageMarker'].url = getMarkerImage('unchecked', curPoiListMarkerInfo.index + 1);
        }
        curPoiListMarkerInfo = { floor: item.floor, id: item.poiId, index: index };
      });
      console.log('poiListMarkers:', poiListMarkers);
      console.log('curPoiListMarkerInfo:', curPoiListMarkerInfo);
      console.log('---------结束---------');
    },
    // 搜索poi
    async searchPoiApi (searchValue, buildId) {
      try {
        let res = await this.$apis.nav.queryAllPoiList({ buildId, searchValue });
        let data = JSON.parse(res.data);
        let arr = [];
        console.log('this.allNodeObjById', this.allNodeObjById);
        data.forEach(item => {
        // 如果该POI有对应的节点
          if (this.allNodeObjById.hasOwnProperty(item.beaconId)) {
            let node = this.allNodeObjById[item.beaconId];
            let obj = {
              id: item.beaconId,
              poiId: item.itemId,
              name: item.itemName,
              images: item.images,
              itemRemark: item.itemRemark,
              buildId: item.buildId,
              x: node.x,
              y: node.y,
              floor: parseInt(node.floor),
              showFloor: this.buildInfo.floorNameList ? this.buildInfo.floorNameList[node.floor - 1] : node.floor
            };
            arr.push(obj);
          }
        });
        console.log('所有poi列表:', arr);
        return arr;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 地图加载完成
    loadComplete (obj) {
      // 存放地图实例
      mapObj = obj.map;
      // 存放定位标注
      locationMarker = obj.locationMarker;
      // 2D/3D模式控件赋值
      this.mapViewMode = mapObj.getViewMode();
      // 拿到地图所有楼层id数组
      this.mapFloorIdList = mapObj.getLevels();
      // 设置聚焦楼层
      this.mapFocusFloor = mapObj.getLevel();
      // 聚焦楼层改变事件
      mapObj.on('levelChanged', event => {
        console.log('聚焦楼层改变事件');
        if (parseInt(event.level) === parseInt(this.mapFocusFloor)) { return; }

        // 获取映射楼层
        this.mapFocusFloor = event.level;

        // 设置楼层控件聚焦楼层
        this.$nextTick(() => {
          this.$refs.floorCtrl && this.$refs.floorCtrl.setFloor(event.level);
        });

        // 隐藏3D精模轮廓面
        if (this.buildInfo.outLine === 0) {
          let floor = mapObj.getFloor(mapObj.getLevel());
          let layers = floor.getLayers();
          for (let index = 0; index < layers.length; index++) {
            let layer = layers[index];
            if (layer.type === fengmap.FMType.EXTENT_LAYER) {
              layer.visible = false;
            }
          }
        }
        mapObj.setVisibleLevels([this.mapFocusFloor], () => {
          mapObj.setLevel({ level: this.mapFocusFloor, duration: 0.1, animate: true, finish: () => {
            this.updateFlabel()
            eventEmitter.emit('focusGroupIDChanged', event);
          } });
        });
      });
      console.log('加载完成1');
      // 在地图对应楼层上显示当前设备位置
      this.showCurLocationInMap();
      console.log('加载完成3');
      if (this.deviInfo.mapInitAngle) {
        mapObj.setRotation({
          rotation: this.deviInfo.mapInitAngle,
          animate: true,
          duration: 0.2,
          finish: () => {
            this.deviInfo.mapInitTilt && mapObj.setTilt({
              tilt: this.deviInfo.mapInitTilt,
              animate: true,
              duration: 0.2,
              finish: () => {
                if (this.deviInfo.mapInitScale) {
                  // let zoom = 24 - Math.log10(parseInt(this.deviInfo.mapInitScale / 70.5)) / Math.log10(2)
                  // zoom = zoom > 0 ? (parseInt(zoom.toFixed(2) * 100) / 100) : 23;
                  // console.log('zoom', zoom);
                  mapObj.setZoom({
                    zoom: this.deviInfo.mapInitScale,
                    animate: true,
                    duration: 0.2,
                    finish: () => {
                      if (deviInfo) {
                        this.changeFloor(parseInt(deviInfo.floor), () => {
                          mapObj.setCenter({ x: deviInfo.x, y: deviInfo.y });
                        });
                      }
                    }
                  });
                }
              }
            });
          }
        });
      } else {
        // 聚焦当前设备位置
        this.focusLocation();
      }
      // 监听聚焦楼层改变，在地图对应楼层上显示当前设备位置
      eventEmitter.on('focusGroupIDChanged', this.showCurLocationInMap);
      console.log('加载完成4', isRotate);
      if (isRotate) {
        const interacation = mapObj.getInteracations();
        interacation.enableRotate = false;
      }
      if (isTiltAngle) {
        const interacation = mapObj.getInteracations();
        interacation.enableTilt = false;
      }
    },
    // 点击地图事件
    mapClickNode (event) {
      console.log('点击地图：', event);

      // 如果正在导航 不允许点击
      if (this.isRunningSimulationNav) { return; }
      // 如果当前是搜索结果列表，不允许点击
      if (this.curShowModel === this.showModelEnum.searchPoiCategroy) { return; }
      this.poiSearchResultData = [];
      // 当前楼层的节点数据
      let curNodeList = this.allPoiFromFloor[this.mapFocusFloor];
      console.log('当前楼层数据：', curNodeList);

      // 查找最近的节点
      let min = 999;
      let minIndex = 0;
      curNodeList.forEach((item, index) => {
        let distance = this.$utils.getTwoPointsDistance(event.coords, item);
        if (distance < min) {
          min = distance;
          minIndex = index;
        }
      });

      let nearPoi = curNodeList[minIndex];

      console.log('点击最近的节点：', minIndex, nearPoi);
      if (!nearPoi) return;
      this.closePoiSearchResult();
      // 添加临时标注点
      this.addFuzhuMarker(nearPoi);

      this.curShowModel = this.showModelEnum.poiInfo;
      this.$nextTick(() => {
        this.$refs.poiInfo.init(nearPoi, 'clickMap');
      });
    },
    showSelectPoint (poi) {
      this.closePoiSearchResult();
      // 添加临时标注点
      this.addFuzhuMarker(poi);

      this.curShowModel = this.showModelEnum.poiInfo;
      this.$nextTick(() => {
        this.$refs.poiInfo.init(poi, 'clickMap');
      });
    },
    // 添加临时标注点并聚焦
    addFuzhuMarker (point) {
      console.log('point', point, fuzhuMarker);
      // 聚焦点击位置
      this.changeFloor(parseInt(point.floor), () => {
        mapObj.setCenter({ x: point.x, y: point.y, animate: true, duration: 0.3 });
        mapObj.setZoom({ zoom: MAP_SCALE_LEVEL });
        // 添加临时标注点
        if (fuzhuMarker) {
          fuzhuMarker.remove();
        }
        fuzhuMarker = this.$refs.fengMap.addImageMarker({ x: point.x, y: point.y, size: 40, url: '/images/preloader/map/marker1.png' });
      });
    },
    // 手动切换楼层
    clickChangeFloor (floor, fn) {
      if (this.isRunningSimulationNav) {
        return;
      }
      floor = parseInt(floor);
      mapObj.setVisibleLevels([floor], () => {
        mapObj.setLevel({ level: floor, duration: 0.1, animate: true, finish: () => {
          fn ? fn() : '';
        } });
      });
    },
    // 切换楼层
    changeFloor (floor, fn) {
      floor = parseInt(floor);
      mapObj.setVisibleLevels([floor], () => {
        mapObj.setLevel({ level: floor, duration: 0.1, animate: true, finish: () => {
          fn ? fn() : '';
        } });
      });
    },
    // 23D切换
    change3D () {
      let curMode = mapObj.getViewMode();
      let mode_2d = fengmap.FMViewMode.MODE_2D;
      let mode_3d = fengmap.FMViewMode.MODE_3D;
      if (curMode === mode_2d) {
        mapObj.setViewMode({ mode: mode_3d });
        this.mapViewMode = mode_3d;
      } else {
        mapObj.setViewMode({ mode: mode_2d });
        this.mapViewMode = mode_2d;
      }
    },
    // 缩放
    mapZoomChange (type) {
      if (type === 1) {
        mapObj.zoomIn();
      } else {
        mapObj.zoomOut();
      }
    },
    // 聚焦当前设备位置
    focusLocation () {
      console.log('建筑信息', this.deviInfo, this.allNodeObjById, deviInfo);
      if (deviInfo) {
        this.changeFloor(parseInt(deviInfo.floor), () => {
          mapObj.setCenter({ x: deviInfo.x, y: deviInfo.y });
          mapObj.setZoom({ zoom: MAP_SCALE_LEVEL });
        });
      }
    },
    // 在地图上显示当前设备位置
    showCurLocationInMap () {
      console.log('设备当前位置', deviInfo);
      this.updateFlabel()
      if (!deviInfo) return;
      // 如果非当前层则不显示
      if (this.mapFocusFloor === deviInfo.floor) {
        // if (curLocationMarker.imageMarker && curLocationMarker.domMarker) {
        //   curLocationMarker.imageMarker.visible = true;
        //   curLocationMarker.domLayer.visible = true;
        //   return
        // }
        curLocationMarker.imageMarker = this.$refs.fengMap.addImageMarker({ x: deviInfo.x, y: deviInfo.y, size: 60, url: '/images/preloader/map/curLocation.png' });
        curLocationMarker.domMarker = this.$refs.fengMap.addDomMarker({
          x: deviInfo.x,
          y: deviInfo.y,
          domWidth: '1',
          domHeight: '1',
          content: `<div class="curLocationInfo">您的位置</div>`,
          anchor: fengmap.FMMarkerAnchor.CENTER
        });
      } else {
        // curLocationMarker.imageMarker.visible = false;
        // curLocationMarker.domLayer.visible = false;
        // let group = mapObj.getFMGroup(deviInfo.floor);
        // let imageLayer = group.getOrCreateLayer('imageMarker');
        // let domLayer = group.getOrCreateLayer('domMarker');
        // imageLayer.removeMarker(curLocationMarker.imageMarker);
        // domLayer.removeMarker(curLocationMarker.domMarker);
      }
    },
    // 设置并显示定位标注
    setLocationMarkerPosition (coord) {
      locationMarker.moveTo(coord);
      locationMarker.visible = true;
    },
    // 长坦市人民医院定制修改
    updateFlabel () {
      console.log('mapObj.getLevel()', mapObj.getLevel())
      if (updateTextBuildId[this.buildInfo.buildId] === mapObj.getLevel()) {
        analyser = new fengmap.FMSearchAnalyser({ map: mapObj }, function () {
          // 查询当前楼层label
          search();
        });
        if (ctyytextMarkers.length === 0 && addTextJson[this.buildInfo.buildId]) {
          addTextJson[this.buildInfo.buildId].forEach((item) => {
            let ctyytextMarker = this.$refs.fengMap.addTextMarker({
              height: 1,
              x: item.x,
              y: item.y,
              text: item.text,
              fillcolor: '60,65,70',
              fontsize: 14,
              strokeColor: '255,255,255', // 文本标注边线颜色
            });
            ctyytextMarkers.push(ctyytextMarker)
          });
          
        } 
      }
      /* 修改标注文本 */
      function updateVisible () {
        searchResult.forEach(function (item) {
          item.setText('')
          item.visible = false;
        });
      }
      /* 查询的代码，必须放在分析器的构造完成的回调中执行 */
      function search () {
        // 封装请求参数
        let searchRequest = new fengmap.FMSearchRequest();
        searchRequest.levels = [mapObj.getLevel()];
        searchRequest.type = fengmap.FMType.LABEL;
        // 执行搜索
        analyser.query(searchRequest, function (result) {
          searchResult = mapObj.getNodes(result) || [];
          searchResult = searchResult.filter(function (item) {
            return textJson[item.FID]
          });
          updateVisible()
          console.log('查询结果', searchResult);
        });
      }
    },
    // 根据模块创建WS
    connectWS () {
      this.WS = new ReconnectingWebSocket(process.env.VUE_APP_WS_URL + '/websocket/config/' + this.deviInfo.accessToken);
      this.WS.addEventListener('open', () => {
        console.log(`ws--open`);

        // 定时请求服务端版本号
        this.checkForUpdatesTimer = setInterval(() => {
          this.WS.send(JSON.stringify({ 'cmd': 'WS_VERSION' }));
        }, 60 * 1000);
      });
      this.WS.addEventListener('message', event => {
        const data = JSON.parse(event.data);
        // console.log('ws--message：', data);

        // 检查版本号是否一致
        let version = Cookies.get('version');
        if (version) {
          if (version !== data.m) {
            this.$alert('检测到有的新版本，即将更新！', {
              confirmButtonText: '确定',
              callback: action => {
                Cookies.set('version', data.m, { expires: 30 });
                location.reload(true);
              }
            });
          }
        } else {
          Cookies.set('version', data.m, { expires: 30 });
        }
      });
      this.WS.addEventListener('close', () => {
        console.log(`ws--close`);
        clearInterval(this.checkForUpdatesTimer);
      });
      this.WS.addEventListener('error', err => {
        console.error(`ws--error--${err}`);
        clearInterval(this.checkForUpdatesTimer);
      });
    }
  }
};
</script>

<style scoped lang="scss">

.wrap {
  height: 100%;
  width: 100%;
  background: url("/images/preloader/bg-main.jpg") center center no-repeat;
  background-size: 100% 100%;
}
.main {
  display: flex;
  min-width: 1000px;
  height: 100%;
  padding: 70px 0 0 0;
  box-sizing: border-box;
  position: relative;
  .left {
    flex: 1;
    position: relative;
    overflow: hidden;
    width: 80%;
    .control {
      position: absolute;
      bottom: 0;
      right: 40px;
      width: 45px;
      z-index: 99;
      display: flex;
      flex-direction: column-reverse;
      padding: 0 0 40px 0;
      box-sizing: border-box;
      .music-ctrl {
        width: 45px;
        height: 45px;
        img {
          width: 100%;
        }
      }
      .modeCtrl {
        position: relative;
        left: -5px;
      }
    }
    .poi-categroy {
      position: absolute;
      bottom: 0;
      left: 0;
      // width: 100%;
      z-index: 9;
      // width: 1050px;
      background: rgba(0,0,0,0.4);
      padding-right: 20px;
      border-radius: 8px;
    }
  }
  .right {
    width: 20vw
    // padding: 63px 0 0 0;
  }
}

.focus-location {
  width: 50px;
  height: 50px;
}
// 3D控件
.modeCtrl img {
    width: 50px;
    height: 50px;
  }
.mode2d {
  background: url("/images/preloader/map/button_qiehuan_2d_01.png") center
    center no-repeat;
  background-size: 100%;
}
.mode3d {
  background: url("/images/preloader/map/button_qiehuan_3d_01.png") center
    center no-repeat;
  background-size: 100%;
}
.nav-tip {
  width: 88%;
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  margin: 0 40px;
  background: $color-opacity-regular;
  border-radius: 20px;
  padding: 0 40px;
  box-sizing: border-box;
  color: $color-white;
  z-index: 2;
  &-left {
    font-size: 26px;
    display: flex;
    align-items: center;
    img {
      height: 50px;
    }
  }
  &-right {
    font-size: 26px;
    display: flex;
    & > div {
      margin: 0 0 0 20px;
    }
  }
}
.simulationNav-btn {
  position: absolute;
  right: 110px;
  bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: $color-white;
  .zanting {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 50px;
    background: url("/images/preloader/button_zanting.png") no-repeat;
    background-size: 120px 50px;
    margin: 0 30px 0 0;
    span {
      margin: 0 20px 0 0;
    }
    img {
      width: 20px;
    }
  }
  .sudu {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 50px;
    background: url("/images/preloader/button_sudu.png") no-repeat;
    background-size: 180px 50px;
    & > span {
      flex: 1;
      height: 40px;
      line-height: 40px;
      border-right: 1px solid #b9beda;
      &:last-child {
        border: none;
      }
    }
    .select {
      position: absolute;
      top: -191px;
      right: 13px;
      width: 70px;
      height: 150px;
      background: url("/images/preloader/button_qiehuan.png") no-repeat;
      background-size: 70px 150px;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      justify-content: center;
      &-btn {
        flex: 1;
        border-bottom: 1px solid #b9beda;
        line-height: 90px;
        &:last-child {
          border: none;
        }
      }
    }
  }
}
.simNavEnd {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: $color-opacity-regular;
  z-index: 9999;
  .container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 788px;
    height: 478px;
    background: url("/images/preloader/rect3.png");
    background-size: 100%;
    color: $color-white;
    padding: 50px 70px;
    box-sizing: border-box;
    .title {
      font-size: 36px;
      color: #21feaf;

      text-align: center;
    }
    .subtitle {
      font-size: 24px;
      text-align: center;
      margin: 20px 0 0 0;
    }
    .journey {
      margin: 40px 0 0 0;
      text-align: center;
      position: relative;
      &-item{
        display: flex;
        justify-content: left;
        align-items: center;
        margin: 0 0 40px 0;
        .name{
          font-size: 30px;
          margin: 0 0 0 20px;
        }
        .subInfo{
          font-size: 24px;
          margin: 0 0 0 20px;
        }
      }
      &-start {
      }
      &-end {
      }
      .fuzhudian{
        position: absolute;
        top: 50%;
        left: 2px;
        display: flex;
        flex-direction: column;
        transform: translate(0,-50%);
        i{
          width: 10px;
          height: 10px;
          margin: 5px 0;
          background: #85a0bd;
          display: inline-block;
          border-radius: 50%;
        }
      }
    }
    .btn-group {
      position: absolute;
      bottom: 50px;
      left: 0;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 26px;
      .close,
      .again {
        width: 180px;
        height: 60px;
        line-height: 60px;
        border-radius: 50px;
        background: #3c6492;
        box-shadow: 0 0 10px $color-opacity-primary;
      }
      .again {
        margin: 0 0 0 40px;
      }
    }
  }
}
.tipImg{
  position: absolute;
  top: 190px;
  left: 40px;
  width: 35%;
  height: auto;
  border-radius: 10px;
  z-index: 2;
}
.is-changing {
  position: absolute;
  top: calc(50% - 250px);
  right: 0;
  left: 0;
  margin: auto;
  width: 190px;
  height: 148px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.65);
  z-index: 20;
  color: #fff;
  font-size: 20px;
  .nav-img {
    width: 56px;
    margin-bottom: 16px;
  }
}

@media (orientation: portrait) {
  .wrap {
    display: flex;
    flex-direction: column;
  }
  .main {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    // flex-direction: column;
    padding: 0;
    .left{
      width: 100%;
      flex: 1;
      .control {
        position: absolute;
        bottom: 0;
        right: 40px;
        width: 142px ;
        z-index:99;
        display: flex;
        flex-direction: column-reverse;
        padding: 0 0 40px 0;
        box-sizing: border-box;
        .music-ctrl {
          width: 145px;
          height: 145px;
          img {
            width: 100%;
          }
        }
        .modeCtrl {
          font-size: 50px;
          color: #fff;
          background: $color-opacity-primary;
          padding: 18px;
        }
      }
    }
    .right {
      margin-top: 2.96vw;
      display: flex;
      width: 100%;
      height: 41.48vw;
      padding: 0 2.96vw;
      box-sizing: border-box;
      justify-content: space-between;
    }
    .poi-categroy{
      width: 55.56vw;
    }
    .wrap-poi{
      width: 100%;
    }
  }
  .focus-location {
    width: 142px;
    height: 142px;
  }
  .simulationNav-btn{
    bottom:80px;
    right:400px;
    transform: scale(2.4);
  }
  .simNavEnd {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: $color-opacity-regular;
    z-index: 9999;
    .container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 1600px;
      height: 885px;
      background: rgba(46,90,141,0.94);
      color: $color-white;
      padding: 50px 70px;
      box-sizing: border-box;
      border-radius: 20px;
      .title {
        font-size: 64px;
        color: #21feaf;

        text-align: center;
      }
      .subtitle {
        font-size: 46px;
        text-align: center;
        margin: 20px 0 0 0;
      }
      .journey {
        margin: 40px 0 0 0;
        text-align: center;
        position: relative;
        &-item{
          display: flex;
          justify-content: left;
          align-items: center;
          margin: 0 0 40px 0;
          .name{
            font-size: 46px;
            margin: 0 0 0 20px;
          }
          .subInfo{
            font-size: 46px;
            margin: 0 0 0 20px;
          }
        }
        &-start {
        }
        &-end {
        }
        .fuzhudian{
          position: absolute;
          top: 50%;
          left: 2px;
          display: flex;
          flex-direction: column;
          transform: translate(0,-50%);
          i{
            width: 10px;
            height: 10px;
            margin: 5px 0;
            background: #85a0bd;
            display: inline-block;
            border-radius: 50%;
          }
        }
      }
      .btn-group {
        position: absolute;
        bottom: 50px;
        left: 0;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 46px;
        .close{
          padding: 20px;
          width: 300px;
        }
        .again {
          padding: 20px;
          width: 300px;
          border-radius: 50px;
          background: linear-gradient(180deg, #2DD79A 0%, #0C9962 100%);
          color: $color-white;
        }
      }
    }
  }
}

</style>

<style lang="scss">
.curLocationInfo {
  position: absolute;
  width: 120px;
  height: 45px;
  line-height: 45px;
  left: -60px;
  top: -70px;
  background: rgba(46, 89, 113, 0.8);
  border-radius: 10px;
  font-size: 22px;
  color: $color-white;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translate(-50%, 0);
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-top: 10px solid rgba(46, 89, 113, 0.8);
  }
}
.no-show {
  position: absolute;
  top: -100px;
  left: -100px;
}
</style>
